import { PlaidAccount } from "react-plaid-link";

export const selectorPlaidAccountName = (plaidAccount: PlaidAccount) =>
  plaidAccount.mask
    ? `${plaidAccount.name} (${plaidAccount.mask})`
    : plaidAccount.name;
